import { Batch } from '@/models/Batch';
import { Silo } from '@/models/Silo';
import { RationEndPrediction } from '@/models/Documents';
import { NutritionalPlan } from '@/models/NutritionalPlan';

export const mutations = {
  SET_SHEDS_ENTHALPY_COUNT(state, value) {
    state.shedsEnthalpyCount = value;
  },

  SET_SHEDS(state, value) {
    state.sheds = value;
  },

  SET_PCP_SHEDS(state, value) {
    state.pcpSheds = value;
  },

  SET_TOTAL_SHEDS(state, value) {
    state.totalSheds = value;
  },

  SET_SELECTED_SHED(state, value) {
    state.selectedShed = value;

    if (
      !state.selectedBatch ||
      !state.selectedShed.batches.map((b) => b.id).includes(state.selectedBatch.id)
    ) {
      state.selectedBatch = value ? value.lastBatch : null;
    }
  },

  SET_SELECTED_SHED_AMBIENTANCE(state, value) {
    state.selectedShedAmbientance = value;
  },

  SET_APPEND_SELECTED_SHED_AMBIENTANCE(state, value) {
    state.selectedShedAmbientance = [...state.selectedShedAmbientance, value];
  },

  SET_SHED_DIVISION_ENTHALPY(state, value) {
    state.shedDivisionEnthalpy = value;
  },

  SET_SELECTED_SHED_AMBIENTANCE_FULL(state, value) {
    state.selectedShedAmbientanceFull = value;
  },

  SET_RATION_PREDICTION(state, payload) {
    state.rationPrediction = payload;
  },

  RESET_SELECTED_SHED_AMBIENTANCE(state) {
    state.selectedShedAmbientance = [];
  },

  RESET_SHED_DIVISION_ENTHALPY(state) {
    state.shedDivisionEnthalpy = [];
  },

  RESET_SELECTED_SHED_AMBIENTANCE_FULL(state) {
    state.selectedShedAmbientanceFull = [];
  },

  RESET_SELECTED_SHED(state) {
    state.selectedShed = null;
  },

  SET_SELECTED_BATCH(state, batch) {
    state.selectedBatch = batch;
    
    if (Array.isArray(batch?.batchDivisions) && batch?.batchDivisions?.length > 0) {
      state.selectedBatchDivision = state.selectedBatch.batchDivisions[0];
      state.selectedBatchDivisions = state.selectedBatch.batchDivisions;
    }
  },

  SET_SELECTED_BATCH_DIVISION(state, value) {
    state.selectedBatchDivision = value;
  },

  SET_DEVICES_LIST(state, value) {
    state.selectedShed.devicesList = value;
  },

  SET_SHEDS_IS_LOADED(state, value) {
    state.shedsIsLoaded = value;
  },

  SET_DASHBOARD_SETTINGS(state, value) {
    state.dashboards = value;
  },

  SET_SINGLE_PROPERTY(state, value) {
    state.singleProperty = value;
  },
  SET_LOADED_BATCH_ID(state, value) {
    state.loadedBatchId = value;
  },
  TOGGLE_SELECTED_BATCH_DIVISION(state, batchDivision) {
    const exists = state.selectedBatchDivisions.find((b) => b.id === batchDivision.id);
    if (exists) {
      state.selectedBatchDivisions = state.selectedBatchDivisions.filter(
        (b) => b.id !== batchDivision.id
      );
    } else {
      state.selectedBatchDivisions.push(batchDivision);
    }
  },

  SET_LINEAGES(state, value) {
    state.lineages = value;
  },

  SET_SEXES(state, value) {
    state.sexes = value;
  },

  SET_PRODUCTION_TYPE(state, value) {
    state.productionType = value;
  },

  SET_BREEDING_TYPE(state, value) {
    state.breedingType = value;
  },
  SET_MORTALITY(state, value) {
    state.mortality = value;
  },

  SET_SELECTED_BATCH_CONSUMPTION_HISTORY(state, history) {
    if (!state.selectedBatch) return;

    state.selectedBatch = {
      ...state.selectedBatch,
      consumptionHistory: history,
    };
  },

  SET_BATCH_SILO_OCCUPATION_HISTORY(state, { siloId, history }) {
    const batch = state.selectedBatch;
    if (!batch) return;

    const silos = batch.silos.map((silo) => {
      if (silo.id === siloId) {
        return {
          ...silo,
          occupationHistory: history,
        };
      }
      return silo;
    });

    state.selectedBatch = {
      ...batch,
      silos,
    };
  },
};
